export default "__VITE_ASSET__CwADQDEo__"